import { createContext, FunctionComponent, useState } from "react";

interface StoreContextValue {
  // Used for showing/hiding the tenant switcher
  forceTenantSwitcher: boolean;
  setForceTenantSwitcher: (value: boolean) => void;
}

export const StoreContext = createContext<StoreContextValue>({
  forceTenantSwitcher: false,
  setForceTenantSwitcher: () => {},
});

// This is the component that actually stores all the global state, and passes
// it down through the tree with context.
// TODO: we should use some kind of global state management library to prevent
// too many re-renders when this data changes.
export const StoreProvider: FunctionComponent = ({ children }) => {
  const [forceTenantSwitcher, setForceTenantSwitcher] = useState(false);

  return (
    <StoreContext.Provider
      value={{
        forceTenantSwitcher,
        setForceTenantSwitcher,
      }}
    >
      {children}
    </StoreContext.Provider>
  );
};
